import { columns } from './helpers'
import { Add as AddIcon } from '@mui/icons-material'
import { useState } from 'react'
import { toTableRowItems } from './serializers'
import { AdminDepositModal } from './AdminDepositModal'
import { EditActionIcon } from 'icons'
import { Box } from '@mui/material'
import s from './AdminDeposit.modules.scss'
import { makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { formatErrorMessage } from 'utils/formatting'
import { Table } from 'components/core-ui/Table'
import { useNotification } from 'hooks'
import { getDepositEditFlags, getScreenPermissions } from "../../api";
import { SCREENS } from '../../constants'

const AdminDeposit = () => {
  const { showNotification } = useNotification()
  const [tableItems, setTableItems] = useState<AdminDeposit[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isNewModalOpen, setIsNewModalOpen] = useState<boolean>(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)
  const [selectedRow, setSelectedRow] = useState<AdminDeposit>()
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)

  const openNewModal = () => setIsNewModalOpen(true)
  const closeNewModal = () => setIsNewModalOpen(false)

  const openEditModal = () => setIsEditModalOpen(true)
  const closeEditModal = () => setIsEditModalOpen(false)

  const selectRow = (rowId: number | string) => {
    setSelectedRow(tableItems.find(item => item.id === rowId))
    openEditModal()
  }

  const { data: permissions } = getScreenPermissions(showNotification, SCREENS.ADMIN_DEPOSIT)
  const { data: editFlags } = getDepositEditFlags(showNotification)

  const fetchData = async ({ page, rowsPerPage, order, orderBy }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/shop-reception/deposits',
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  return (
    <div className={s.mainContainer}>
      <Box>
        <AdminDepositModal
          isModalOpen={isNewModalOpen}
          closeModal={closeNewModal}
          setShouldRefreshData={setShouldRefreshData}
        />
        <AdminDepositModal
          isModalOpen={isEditModalOpen}
          closeModal={closeEditModal}
          setShouldRefreshData={setShouldRefreshData}
          editItem={selectedRow}
          isEdit
        />
        <Table
          hideCheckbox
          orderBy="created"
          order="desc"
          columns={columns}
          items={tableItems}
          fetchData={fetchData}
          isLoading={isLoading}
          totalCount={totalCount}
          shouldRefreshData={shouldRefreshData}
          setShouldRefreshData={setShouldRefreshData}
          rowActionsWidth="130px"
          toolbarActions={
            permissions?.canAdd
              ? [
                  {
                    label: 'Adauga',
                    icon: <AddIcon />,
                    onClick: () => openNewModal()
                  }
                ]
              : []
          }
          rowActions={
            permissions?.canEdit || editFlags?.canEditValidityPercentage
              ? [
                  {
                    label: 'Edit',
                    labelColor: 'white',
                    typographyVariant: 'medium',
                    backgroundColor: '#16a085',
                    desktopIcon: <EditActionIcon />,
                    onClick: (_e, rowId: number) => selectRow(rowId)
                  }
                ]
              : []
          }
          rowsPerPage={10}
          rowsPerPageOptions={[10, 25, 50]}
        />
      </Box>
    </div>
  )
}

export default AdminDeposit
